import { FilterType } from './action';
import { FilterState, FilterValues } from './state';

import { Action } from '../action';
import { AuthType } from '../Auth/action';

import { Account, ClientType, ConstructionType, EnergyLabel, LoanForm, NHG } from '../../Enum/Filters/';
import { Decorator, Filter } from '../../Enum/Filters';
import InterestUri from '../../Enum/InterestUri';
import { compareFilterValuesWithInitial } from '../../Helpers/Filter';
import moment from 'moment';

export const initialDecoratorValues = {
    [Decorator.Sorting]: {
        [InterestUri.MarketValue]: { ascending: true },
        [InterestUri.FixedPeriod]: { ascending: true },
        [InterestUri.Product]: { ascending: true },
        [InterestUri.PropertiesPerLabel]: { ascending: true },
        [InterestUri.PropertiesPerProperty]: { ascending: true },
        [InterestUri.InterestNews]: { ascending: true },
        [InterestUri.BridgingLoan]: { ascending: true },
        [InterestUri.PropertiesNews]: { ascending: true },
    },
};

const initialFilterValues: FilterValues = {
    [Filter.ConstructionType]: ConstructionType.Existing,
    [Filter.EnergyLabel]: EnergyLabel.C,
    [Filter.FixedPeriod]: '120',
    [Filter.FixedPeriods]: [
        { period: 1 },
        { period: 12 },
        { period: 60 },
        { period: 120 },
        { period: 180 },
        { period: 240 },
        { period: 300 },
        { period: 360 },
    ],
    [Filter.Label]: '',
    [Filter.Labels]: [],
    [Filter.LoanForm]: LoanForm.Annuïtair,
    [Filter.ModificationLoanForm]: '',
    [Filter.ModificationLoanFormName]: 'Annuïtair',
    [Filter.NewsLabels]: [],
    [Filter.NHG]: NHG.Nee,
    [Filter.MortgageProperties]: [],
    [Filter.RiskCategory]: '100',
    [Filter.DateFrom]: '',
    [Filter.DateTo]: '',
    [Filter.ClientType]: ClientType.NEW,
    [Filter.BridgingLoanLabels]: [],
    [Filter.Account]: Account.Ja,
};

export const initialState: FilterState = {
    decoratorValues: initialDecoratorValues,
    filterValues: { ...initialFilterValues },
    filteredValues: { ...initialFilterValues },
    loading: false,
    toggledPropertyCategories: []
};

export const filterReducer = (state: FilterState | undefined, action: Action): FilterState => {
    state = state ?? initialState;

    switch (action.type) {
        case FilterType.filterHasChanged:
            return {
                ...state,
                loading: false,
                filterValues: {
                    ...state.filterValues,
                    [action.name]: action.value,
                },
            };
        case FilterType.sortChanged:
            return {
                ...state,
                loading: false,
                decoratorValues: {
                    ...state.decoratorValues,
                    [Decorator.Sorting]: {
                        ...state.decoratorValues[Decorator.Sorting],
                        [action.section]: action.value,
                    },
                },
            };
        case FilterType.filterIsSubmitted:
            return {
                ...state,
                filteredValues: { ...state.filterValues },
                loading: true,
            };
        case FilterType.togglePropertyCategory:
            return {
                ...state,
                toggledPropertyCategories: state.toggledPropertyCategories.includes(action.name)
                    ? state.toggledPropertyCategories.filter(name => name !== action.name)
                    : [...state.toggledPropertyCategories, action.name]
            };
        case FilterType.filterIsFinishedLoading:
            return { ...state, loading: false, fetchedAt: moment() };
        case FilterType.filterResetRequest:
            return { ...initialState, loading: !compareFilterValuesWithInitial(state.filteredValues) };
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
